import s from "./TourScheduleLayout.module.scss";
import Itinerary from "../Itinerary/Itinerary";
import TourInfo from "../TourInfo/TourInfo";
import Sample from "../Sample";
import LineBookingCard from "../LineBookingCard/LineBookingCard";

const TourScheduleLayout = ({
  showCustomize = false,
  scheduleItems = [],
  price,
  detailItems = [],
  includedItems = [],
  notIncludedItems = [],
  showScheduleImages = true,
}) => {
  return (
    <section className={s.root}>
      <div className={s.left}>
        {showCustomize ? (
          <Sample isTourDetail />
        ) : (
          <Itinerary scheduleItems={scheduleItems} showImages={showScheduleImages} />
        )}
      </div>

      <aside className={s.right}>
        <TourInfo
          price={price}
          detailItems={detailItems}
          includedItems={includedItems}
          notIncludedItems={notIncludedItems}
        />

        <LineBookingCard />
      </aside>
    </section>
  );
};

export default TourScheduleLayout;
